var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "custom-class": "OrderPre-Dialog-Pay OrderPre-Dialog container",
        "destroy-on-close": true,
        "append-to-body": true,
        title: "",
        visible: _vm.staticPayShow,
      },
      on: {
        "update:visible": function ($event) {
          _vm.staticPayShow = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%", height: "600px" },
          attrs: {
            "header-cell-style": {
              backgroundColor: "#FDEFE7",
              color: "#000000",
            },
            border: "",
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "date",
              label: "子订单号",
              width: "230",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "tableLine1" }, [
                      _c("div", { staticClass: "btns1" }, [
                        _vm._v(_vm._s(scope.row.stateName)),
                      ]),
                      _c("p", { staticClass: "p1" }, [_vm._v("平台操作记录")]),
                    ]),
                    _c("p", { staticClass: "p2" }, [
                      _vm._v(_vm._s(scope.row.orderChildrenId)),
                    ]),
                    _c("p", { staticClass: "p3" }, [
                      _vm._v(
                        _vm._s(
                          scope.row.resourceName
                            ? scope.row.resourceName
                            : scope.row.resourceNameEn
                        )
                      ),
                    ]),
                    _c("p", { staticClass: "p5" }, [
                      _vm._v(_vm._s(scope.row.stockCompanyName)),
                    ]),
                    scope.row.associatedListMap
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "center",
                            },
                          },
                          _vm._l(
                            Object.keys(scope.row.associatedListMap),
                            function (n, m) {
                              return _c(
                                "span",
                                {
                                  key: m,
                                  staticClass: "btns2",
                                  on: {
                                    click: function ($event) {
                                      return _vm.similarProductsClick(
                                        scope.row.associatedListMap,
                                        n
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(_vm._s(_vm.btnMap[n]) + " "),
                                  _c("i", {
                                    staticClass: "el-icon-arrow-right",
                                    staticStyle: { "font-weight": "bold" },
                                  }),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              width: "400",
              align: "center",
              prop: "name",
              label: "商品",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.orderListDetailResultList,
                    function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "tableLine2" },
                        [
                          _c("p", { staticClass: "p1" }, [
                            _c("span", { staticClass: "span1" }, [
                              _vm._v(
                                _vm._s(item.number) +
                                  " " +
                                  _vm._s(item.priceCompany)
                              ),
                            ]),
                            _c("span", { staticClass: "span2" }, [
                              _vm._v(_vm._s(item.productName)),
                            ]),
                          ]),
                          _c("p", { staticClass: "p1" }, [
                            item.stockId != 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "span2",
                                    staticStyle: {
                                      "font-weight": "400",
                                      color: "#333333",
                                    },
                                  },
                                  [_vm._v(_vm._s(item.stockId) + " ")]
                                )
                              : _vm._e(),
                          ]),
                          _c(
                            "p",
                            {
                              staticClass: "p1",
                              staticStyle: { "margin-bottom": "0" },
                            },
                            [
                              _c("span", { staticClass: "span1" }, [
                                _vm._v(
                                  _vm._s(item.number) +
                                    " " +
                                    _vm._s(item.priceCompany)
                                ),
                              ]),
                              item.startTime == item.endTime
                                ? _c("span", { staticClass: "span4" }, [
                                    _vm._v(_vm._s(item.startTime)),
                                  ])
                                : _c("span", { staticClass: "span4" }, [
                                    _vm._v(
                                      _vm._s(
                                        item.startTime + "-" + item.endTime
                                      )
                                    ),
                                  ]),
                            ]
                          ),
                          _c("p", { staticClass: "p3" }),
                        ]
                      )
                    }
                  )
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "address",
              width: "180",
              label: "单元（元）*数量 *汇率 ",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.orderListDetailResultList,
                    function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "tableLine3" },
                        [
                          _c("p", { staticClass: "p1" }, [
                            _vm._v(
                              _vm._s(item.currency) +
                                _vm._s(item.price) +
                                "/" +
                                _vm._s(item.priceCompany)
                            ),
                            item.useTime ? _c("span", [_vm._v("/")]) : _vm._e(),
                            _vm._v(" " + _vm._s(item.useTime)),
                          ]),
                          _c("p", { staticClass: "p2" }, [
                            _vm._v(
                              _vm._s(item.number + item.priceCompany) +
                                " " +
                                _vm._s(
                                  _vm.days(
                                    item.startTime,
                                    item.endTime,
                                    scope.row.state
                                  ) + 1
                                ) +
                                _vm._s(item.useTime ? item.useTime : "天")
                            ),
                          ]),
                          item.rate != 1
                            ? _c("p", { staticClass: "p3" }, [
                                _c(
                                  "span",
                                  { staticStyle: { color: "#5F6266" } },
                                  [_vm._v(" 汇率：" + _vm._s(item.rate) + " ")]
                                ),
                              ])
                            : _vm._e(),
                          item.cancelNumber > 0
                            ? _c("p", { staticClass: "lp4" }, [
                                _vm._v(
                                  "已取消的数量：" + _vm._s(item.cancelNumber)
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }
                  )
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "name",
              label: "商品总价（元）",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "tableLine4" }, [
                      _c(
                        "p",
                        {
                          staticClass: "p1",
                          staticStyle: { "margin-bottom": "0" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.totalPrice(
                                scope.row.orderListDetailResultList
                              )
                            ) + "￥"
                          ),
                        ]
                      ),
                      _vm.dataType == 1
                        ? _c("p", [
                            _vm._v("利润："),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.profitPrice(
                                    scope.row.orderListDetailResultList
                                  )
                                ) + "¥"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "flex-end",
              },
            },
            [
              _c(
                "p",
                { staticStyle: { color: "red", "margin-right": "0.2rem" } },
                [
                  _vm._v(
                    "子订单无法单独付款，一起下订单的产品需要一起付款！！！"
                  ),
                ]
              ),
              _c("p", [
                _vm._v("总计："),
                _c(
                  "span",
                  { staticStyle: { color: "#d81b43", "font-weight": "700" } },
                  [_vm._v(_vm._s(_vm.payPrice()) + " ¥")]
                ),
              ]),
            ]
          ),
          _c(
            "el-button",
            {
              staticStyle: {
                "margin-top": "15px",
                width: "100px",
                color: "rgb(255, 255, 255)",
                "background-color": "rgb(222, 86, 44)",
                "border-color": "rgb(222, 86, 44)",
              },
              on: { click: _vm.payment },
            },
            [_vm._v("付款")]
          ),
          _c("Pay", {
            ref: "Pay",
            attrs: {
              routeData: "?currentComponent=sonOrder",
              dataMap: { totalPrice: _vm.payPrice() },
              payMoney: Number(_vm.payPrice()),
              orderChildrenIds: _vm.tableData.map((u) => u.orderChildrenId),
              orderMainId: _vm.orderMainId,
            },
            on: { payUpload: _vm.payUpload },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }